import { EnvironmentService } from '@/services/environment';
import { setupDayjsExtensions } from '@/utils/setupDayjsExtensions';
import { environmentManager } from '@tanstack/react-query';
import { Big } from 'big.js';

if (!environmentManager.isServer()) {
  EnvironmentService.init();
}

Big.RM = 2;
Big.DP = 10;

setupDayjsExtensions();
